export const NAME = 'name';
export const INFLUENCER = 'influencerId';
export const OWNER = 'ownerId';
export const SOCIAL_MEDIA_PLATFORM = 'socialMediaPlatformId';
export const INFLUENCER_CHANNEL_URL = 'link';
export const COUNTRY = 'countryCode';
export const CATEGORY = 'categoryId';
export const SUB_CATEGORY = 'subCategoryId';
export const DESCRIPTION = 'description';
export const CONCURRENT_VIEWERS = 'concurrentViewers';

export const AGENCIES = 'agencies';
export const PRICE = 'price';
export const PRICE_WITH_FEE = 'priceWithFee';
export const AGENCY = 'id';

export const SUBSCRIBERS = 'subscribers';
export const VIEWS = 'views';

export const MALE = 'male';
export const FEMALE = 'female';

export const AGE_LIST = ['13-17', '18-24', '25-34', '35+'];

export const AGE_GENDER_DISTRIBUTION = 'ageGenderDistribution';
export const AGE_GROUP_NAME = 'ageGroupName';

export const DEPENDENCIES = {
  [SUB_CATEGORY]: [CATEGORY],
};
